<template>
    <div>
      <div
        id="twitch-embed"
        class="my-1 lg:my-3 mx-auto border border-black rounded-lg overflow-hidden bg-black"
        :style="{ maxWidth: '1100px', height: embedHeight }"
      ></div>
  
      <div class="text-center p-2 lg:w-3/5 mx-auto">
        <h1 class="lg:my-3 place-self-center">
          <img
            :src="taglineImage"
            class="inline select-none"
            alt="Identity is Content"
          />
        </h1>
        <p class="lg:my-2 text-sm lg:text-md font-medium lg:w-4/5 xl:w-10/12 mx-auto" v-bind:style="{ color: underBannerTextColor }">
          {{ underBannerText }}
        </p>
      </div>
    </div>
</template>
<script>
  export default {
    props: {
        channelToHighlight: String,
        taglineImage: String,
        underBannerText: String,
        underBannerTextColor: String,
        minViewerCount: String,
    },
    data() {
      return {
        embedHeight: '0px',
        channels: [],
      };
    },
    mounted() {
      this.setTwitchEmbedStyle();
      this.fetchChannels().then((data) => {
        this.channels = data;
        setTimeout(() => {
          this.initTwitchEmbed();
        }, 1000);
      });
    },
    methods: {
      setTwitchEmbedStyle() {
        const isMobileDevice = window.innerWidth <= 768;
        this.embedHeight = isMobileDevice
          ? 'calc(100vw * 9 / 16)'
          : 'calc(768px / (16 / 9))';
      },
      async fetchChannels() {
        const response = await fetch(
          `${process.env.VUE_APP_NODE_SERVER_BASE_URL}/streams`,
        );
        const data = await response.json();
        return data;
      },
      initTwitchEmbed() {
          setTimeout(() => {
            const minViewers = this.minViewerCount;
            const eligibleChannels = this.channels.filter(
              (channel) => channel.viewers > minViewers
            );
            if (eligibleChannels.length === 0) {
              eligibleChannels = this.channels;
            }
            const randomChannel =
              eligibleChannels[
                Math.floor(Math.random() * eligibleChannels.length)
              ];
            const channel =
              this.channelToHighlight !== ""
                ? this.channelToHighlight
                : randomChannel.name;

            const embedElem = document.getElementById("twitch-embed");
            if (!embedElem) {
              setTimeout(() => this.initTwitchEmbed(channel), 100); // Retry after a short delay
              return;
            }
            const script = document.createElement("script");
            script.src = "https://embed.twitch.tv/embed/v1.js";
            script.onload = () => {
              const isMobileDevice = window.innerWidth <= 768;
              const layout = isMobileDevice ? "video" : "video-with-chat"; // Set layout based on device
              const twitchEmbed = new Twitch.Embed("twitch-embed", {
                width: "100%",
                height: "100%",
                channel: channel,
                layout: layout,
                parent: [process.env.APP_URL],
                onError: function() {},
                onSuccess: function() {}
              });

              embedElem.twitchPlayer = twitchEmbed.getPlayer();
            };
            document.head.appendChild(script);
          }, 1000);
      },
    },
  };
</script>
  